import {
  IonButton,
  IonButtons,
  IonContent,
  IonItem,
  IonLabel,
  IonModal,
  IonSpinner,
  IonText,
  IonTextarea,
} from "@ionic/react";
import { useState } from "react";
import { AppHeader } from "../AppHeader";
import { useRequestAccess } from "@/hooks";
import type { VisibleOrganisation } from "@/types";

export interface RequestAccessModalProps {
  organisation: VisibleOrganisation | null;
  isOpen: boolean;
  onClose: (result?: { success: boolean; message: string }) => void;
}

export default function RequestAccessModal({
  organisation,
  isOpen,
  onClose,
}: RequestAccessModalProps) {
  const [message, setMessage] = useState("");

  const requestMutation = useRequestAccess();

  const handleRequest = async () => {
    if (!organisation) return;

    try {
      await requestMutation.mutateAsync({
        organisationId: organisation.id,
        message: message || undefined,
      });
      onClose({ success: true, message: "Toegangsverzoek verzonden." });
    } catch {
      onClose({
        success: false,
        message: "Er ging iets mis. Probeer het opnieuw.",
      });
    }
  };

  const handleClose = () => {
    setMessage("");
    onClose();
  };

  return (
    <IonModal isOpen={isOpen} onDidDismiss={handleClose}>
      <AppHeader title="Toegang aanvragen" onClose={handleClose} />
      <IonContent className="ion-padding">
        <IonText>
          <p>Vraag toegang aan tot {organisation?.name}</p>
        </IonText>

        <IonItem className="ion-margin-top">
          <IonLabel position="stacked">Bericht (optioneel)</IonLabel>
          <IonTextarea
            value={message}
            onIonInput={(e) => setMessage(e.detail.value || "")}
            placeholder="Voeg een bericht toe aan je verzoek..."
            rows={4}
          />
        </IonItem>

        <IonButtons className="ion-margin-top ion-justify-content-end">
          <IonButton
            fill="clear"
            onClick={handleClose}
            disabled={requestMutation.isPending}
          >
            Sluiten
          </IonButton>
          <IonButton
            fill="solid"
            onClick={handleRequest}
            disabled={requestMutation.isPending}
          >
            {requestMutation.isPending ? (
              <IonSpinner name="crescent" />
            ) : (
              "Verzoek versturen"
            )}
          </IonButton>
        </IonButtons>
      </IonContent>
    </IonModal>
  );
}
